import styled from 'styled-components';
import { CardTitle, Legend, Stack } from '@koob/margaret';
import { daysBetween } from '@koob/dates';
import { DateRange } from 'components';
import { useTranslation } from 'react-i18next';
import { Text, SectionCard } from 'ui';
import { KoobInputStars } from '@koob/ui';

const ItemCard = styled(Stack).attrs({
  size: 'full',
  padding: 0.5,
  gutterSize: 0.5,
})`
  border: 1px solid ${({ theme }) => theme.separator};
  border-radius: ${({ theme }) => theme.borderRadius.default};
`;

const DmcContractHotelInfo = ({ hotel, filters }) => {
  const { t } = useTranslation('bookings');
  const { startAt, endAt, rooms } = filters;
  const daysCount = daysBetween(startAt, endAt);

  return (
    <Stack direction="column" size="full" gutterSize={0.5}>
      <Stack paddingBottom={0.5}>
        <Text type="h2">{t('mySearch')}</Text>
      </Stack>

      <SectionCard>
        <Stack direction="column" size="full" gutterSize={1}>
          <ItemCard>
            <DateRange startAt={startAt} endAt={endAt} size="full" />
          </ItemCard>
          {Boolean(startAt) && Boolean(endAt) && (
            <Stack gutterSize={0.25} alignY="center">
              <i className="fa-light fa-moon" style={{ fontSize: 18 }} />
              <Legend>
                {t('nNightsStay', {
                  count: daysCount,
                  days: daysCount + 1,
                })}
              </Legend>
            </Stack>
          )}

          <ItemCard direction="column" gutterSize={0.25}>
            <CardTitle>{hotel.displayName}</CardTitle>
            <Stack>
              <Legend>{hotel.address}</Legend>
            </Stack>
            <KoobInputStars value={hotel.stars} />
          </ItemCard>

          <ItemCard>
            <Stack gutterSize={0.25} alignY="center">
              <i className="fa-light fa-users" style={{ fontSize: 18 }} />
              <span>
                {t('nGuests', {
                  count: (rooms || []).reduce(
                    (total, { adults, children }) => total + adults + children,
                    0,
                  ),
                })}
              </span>
            </Stack>
            <Stack gutterSize={0.25} alignY="center">
              <i className="fa-regular fa-sitemap" style={{ fontSize: 18 }} />
              <span>{t('nRooms', { count: (rooms || []).length })}</span>
            </Stack>
          </ItemCard>
        </Stack>
      </SectionCard>
    </Stack>
  );
};

export default DmcContractHotelInfo;
